import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useLoadCabinetAdminCommunication } from '@/entities/Cabinet'
import { cloneDeep } from 'lodash'

const useModel = defineStore('cabinet_admin_communication_form', () => {
  /* Данные формы */
  const fields = {
    sim_1: '',
    gsm_profile_1: null,
    iccid_sim_1: '',
    sim_2: '',
    gsm_profile_2: null,
    iccid_sim_2: '',
    unilight_broker: null,
    ntp_server_1: null,
    ntp_server_2: null,
    is_ethernet: false,
    is_lora: false,
    sim_card_priority: 1,
  }

  let data = ref({ ...fields })
  let origin = ref<any>({})

  const gsm_profiles = ref([])
  const ntp_servers = ref([])
  const mqtt_brokers = ref([])

  /* Правила валидации */
  const rules = {}

  /**
   * Функция приведения к дефолтным значениям
   */
  const clearData = () => {
    Object.keys(data).forEach((key) => {
      data[key] = fields[key]
    })
  }

  /**
   * Обновляем данные origin
   */
  const updateOrigin = () => {
    origin.value = cloneDeep(data.value)
  }

  /**
   * Функция загрузки первоначальных данных
   */
  const loadData = () => {
    const result = useLoadCabinetAdminCommunication()

    watch(
      () => result.data.value,
      () => {
        if (result.data.value) {
          data.value = {
            ...data.value,
            ...result.data.value.data,
            ...{
              gsm_profile_1: result.data.value.data.gsm_profile_1 || 0,
              gsm_profile_2: result.data.value.data.gsm_profile_2 || 0,
            },
          }

          updateOrigin()

          gsm_profiles.value = result.data.value.payload.gsm_profiles || []
          mqtt_brokers.value = result.data.value.payload.mqtt_brokers || []
          ntp_servers.value = result.data.value.payload.ntp_servers || []
        }
      },
    )

    return result
  }

  return {
    data,
    rules,
    gsm_profiles,
    ntp_servers,
    mqtt_brokers,
    origin,

    clearData,
    loadData,
    updateOrigin,
  }
})

export default useModel
